import React, { Component } from 'react';
import ResetPasswordComponent from './reset-password.component';

export class SetPasswordComponent extends Component {

  render() {
    return (
      <ResetPasswordComponent title="Set Your Password"/>
    );
  }
}

export default SetPasswordComponent;



// WEBPACK FOOTER //
// src/acct/password/set-password.component.js